export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13280.2935e888.jpg";